import Calendar from "@material-symbols/svg-500/rounded/calendar_month.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const CalendarIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Calendar });
	return <Icon />;
};

export default memo(CalendarIcon);
